$(document).ready(function () {

  setVideoHeight();

  $(window).on( 'resize', setVideoHeight );


    // code from https://gist.github.com/drabbytux/a49215c6d0ba16c4d096a56212bbc4ce
    thumbnails = $('img[src*="/products/"]').not(':first');
    if (thumbnails.length) {
      thumbnails.bind('click', function() {
        var arrImage = $(this).attr('src').split('?')[0].split('.');
        var strExtention = arrImage.pop();
        var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/,'');
        var strNewImage = arrImage.join('.')+"."+strRemaining+"."+strExtention;
        if (typeof variantImages[strNewImage] !== 'undefined') {
            productOptions.forEach(function (value, i) {
             optionValue = variantImages[strNewImage]['option-'+i];
             if (optionValue !== null && $('.single-option-selector:eq('+i+') option').filter(function() { return $(this).text() === optionValue }).length) {
               $('.single-option-selector:eq('+i+')').val(optionValue).trigger('change');
             }
          });
        }
      });
    }
});

function setVideoHeight() {
  // determine if there are any Youtube iframes on this page
  let yt_iframes = $('.product-description iframe');

  // if so, set their height to 16/9 based on current width
  if ( yt_iframes.length > 0 ) {
      let body_width = $('.product-description').width();

      for ( let iframe of yt_iframes ) {
          let this_height = body_width * 9 / 16;
          $(iframe).height(this_height);
          // $(iframe).width("100%");
      }
  }
}